import { ServiceHandler } from '../../../utils/api.utils';

export type AgentTone = {
  id: string;
  name: string;
  content: string; // markdown
  isDefault: boolean;
  modifiedAt: string;
};

export type CreateAgentToneRequest = {
  name: string;
  content: string;
  isDefault: boolean;
};

export const getAgentTones = ServiceHandler<unknown, { content: AgentTone[] }>({
  url: '/api/docmessage/v1/agent-tones',
});

export const createAgentTone = ServiceHandler<
  CreateAgentToneRequest,
  AgentTone
>({
  url: '/api/docmessage/v1/agent-tones',
  method: 'POST',
});

export const updateAgentTone = ServiceHandler<
  CreateAgentToneRequest,
  AgentTone
>({
  url: '/api/docmessage/v1/agent-tones/:id',
  method: 'PUT',
});

export const deleteAgentTone = ServiceHandler<unknown, void>({
  url: '/api/docmessage/v1/agent-tones/:id',
  method: 'DELETE',
});

export const setDefaultAgentTone = ServiceHandler<unknown, AgentTone>({
  url: '/api/docmessage/v1/agent-tones/:id/default',
  method: 'PUT',
});
